<div class="absolute top-0 left-0 h-full w-full">
    <div class="bg-[rgba(242,242,242,1)] h-screen overflow-hidden w-full">
        <div class="h-full relative block w-full overflow-hidden">
            <div class="w-full h-full overflow-hidden relative z-[2]">
                <div class="h-full w-full max-w-full relative grid grid-rows-[minmax(0,min-content)_minmax(0,1fr)] overflow-hidden">
                    <app-header-documentation></app-header-documentation>
                    <router-outlet class="contents"></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>